<script setup lang="ts">
   import { definePageMeta, useHead } from '#imports';

   definePageMeta({
      layout: 'wow-polo',
   });

   useHead({
      title: 'Contact Us — WOW Polo Series',
   });
</script>

<template>
   <div>
      <!-- Hero -->
      <section class="wow-contact-hero relative h-[320px] bg-cover bg-center bg-no-repeat">
         <div class="absolute inset-0 bg-black/50" />
         <div class="relative flex h-full flex-col items-center justify-center px-6 text-center">
            <h1 class="mb-4 text-4xl font-bold text-white md:text-5xl lg:text-6xl">
               Contact Us
            </h1>
            <p class="max-w-xl text-lg text-white/90">
               Interested in learning more about the WOW Polo Series? Get in touch with us.
            </p>
         </div>
      </section>

      <!-- Brevo Form -->
      <section class="bg-white py-16">
         <div class="mx-auto max-w-3xl px-6">
            <div class="flex justify-center">
               <iframe
                  src="https://8e554e48.sibforms.com/serve/MUIFADfsxDNcQmUgXt3LA94bBsUwJNVEqze3EE9i1YDaxTA4OELxPgQndxnflxP-sPEMCaUP8oIeiLtUrrUYNqSpM_3qWQH6am9yj3M2ZdaiML0BhMHSyk0xI4vfPCzTgA7Fm6LcQ7oa605s4KAfrdWuy7JzTbOd0D-5O0vgkgVIzz7Xadbu0yrVN87qkiUSBU16afe6T_Dk_MZ3"
                  width="540"
                  height="450"
                  frameborder="0"
                  scrolling="no"
                  allowfullscreen
                  class="max-w-full rounded-lg">
               </iframe>
            </div>
         </div>
      </section>
   </div>
</template>

<style scoped>
   .wow-contact-hero {
      background-image: url('/img/home-page-hero-bg.webp');
   }
</style>
